import { render, staticRenderFns } from "./exportStats.vue?vue&type=template&id=21dda2cc&"
import script from "./exportStats.vue?vue&type=script&lang=js&"
export * from "./exportStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports